<template>
<div>
      <div class="layout-breadcrumb">
        <Breadcrumb>
            <BreadcrumbItem >
                <Icon type="social-buffer-outline" style="color:#fff"></Icon> 
                <span style="color:#fff">币种管理</span>
            </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <div class="layout-content">
        <div class="layout-content-main">
          <div class="method-wrapper">
            <div style="display:inline-block;" v-if="isbutShow.selectBut">
             <template>
                <Input v-model="key" placeholder="币种名称" style="width: 300px"></Input>
            </template>
              
              <Button type="ghost" class="mRight mLeft" @click="showKeyList()" v-if="isbutShow.selectBut">查询</Button>
              
            </div>
          
            <Button type="primary" class="mRight" v-if="isbutShow.addBut" @click="addAdmin">新增</Button> 

            <Button @click="upDateAdmin" type="primary" class="mRight" v-if="isbutShow.updateBut">修改</Button>
            <Button type="primary" class="mRight" v-if="isbutShow.delBut" @click="delAdmins">删除</Button>
             
          </div>

          <div class="clearfix"></div>
          <div class="table-wrapper">
            <Table style="min-width: 700px" border :columns="columns" :data="pagerData.data" ref="selection" @on-selection-change="getSelection"></Table >
             <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                     <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div> 
         

        </div>
      </div>


  <!-- 新增admin  / 修改-->
    <Modal
      v-model="addModel"
      title="" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{activeName}}</span>
        </p>
        <div style="text-align:center">
          <Form ref="formValidate" label-position="left" :model="formValidate" :rules="ruleValidate" :label-width="150">
              <!-- <FormItem label="币种代码" prop="currencyId">
                  <Input v-model="formValidate.currencyId" placeholder="请输入币种代码"></Input>
              </FormItem> -->
              <FormItem label="币种名称" prop="currencyName">
                  <Input v-model="formValidate.currencyName" placeholder="请输入币种名称"></Input>
              </FormItem>
              <FormItem label="币种英文代码" prop="currencyEid">
                  <Input v-model="formValidate.currencyEid" placeholder="请输入币种英文代码" ></Input>
              </FormItem>
               <!-- <FormItem label="所属部门" prop="dePtNode"> -->
                  <!-- <Button type="default" long  @click="getDepartment">所属部门</Button>    -->
                  <!-- {{treeNode}} -->
                  <!-- <Button type="default" long style="text-align:left;" @click=" modalDept = true " >{{treeNode}}</Button> -->
              <!-- </FormItem> -->
              <FormItem label="保留小数位" prop="decimalDigits">
                  <Input v-model="formValidate.decimalDigits" placeholder="请输入保留小数位"></Input>
              </FormItem>
               <FormItem label="与本位币的拆算方式" prop="convertType">
                  <Input v-model="formValidate.convertType" placeholder="请输入与本位币的拆算方式"></Input>
              </FormItem>
              <!-- <FormItem label="角色" prop="role">

              </FormItem> -->
              <!-- <FormItem label="状态" prop="status" style="text-align:left;">
                  <RadioGroup v-model="formValidate.status">
                    <Radio label="0" :class="[formValidate.status == '0' ? 'ivu-radio-checked' : '']">禁用</Radio>
                    <Radio label="1" :class="[formValidate.status == '1' ? 'ivu-radio-checked' : '']">正常</Radio>
                </RadioGroup>
              </FormItem> -->
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="handleSubmit" long :loading="modal_loading" >确定</Button>
        </div>
    </Modal>
</div>
     
</template>
<style scoped>
  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
    .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
</style>
<script>
  import api from '../../api/apinew'
  //import leftBar from '../../components/leftBar'
  import axios from 'axios'
  import Qs from 'qs'
  export default{
    data(){
      return {
        modal_loading: false,
        addModel: false,
        formValidate: {
            // currencyId:'',
            currencyName:'',
            currencyEid: '',
            decimalDigits: '',
            convertType: '',
        },
        selectionRows:[],
        key:'',
        activeName:'',
        isbutShow:{
          addBut: false,
          delBut: false,
          updateBut: false,
          selectBut: false,
        },
        columns: [
          {
              type: 'selection',
              width: 60,
              align: 'center'
          },
          {   
              title: '币种代码',
              key:'currencyId',
              width: 100,
              align: 'center'
          },
          {
              title: '币种名称',
              key: 'currencyName',
              align: 'center'
          },
          {
              title: '币种英文代码',
              key: 'currencyEid',
              align: 'center',
          },
          {
              title: '保留小数位',
              key: 'decimalDigits',
              align: 'center'
          },
          {
              title: '与本位币的拆算方式',
              key: 'convertType',
              align: 'center',
          },
        ],
        pagerData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  

        },
        ruleValidate: {
            // currencyId: [
            //     { required: true, message: '币种代码不能为空', trigger: 'blur' }
            // ],
            currencyName:[
                // { required: true,validator: validatePass, trigger: 'blur' },
                { required: true, message: '币种名称不能为空', trigger: 'blur' }
            ],
            currencyEid:[
                { required: true, message: '币种英文代码不能为空', trigger: 'blur' }
            ],
            decimalDigits:[
               { required: true, message: '保留小数位不能为空',  trigger: 'blur' }
            ],
            convertType: [
                { required: true, message: '与本位币的拆算方式不能为空', trigger: 'blur' }
            ],
            // phone:[
            //    { required: true, message: '手机号不能为空', trigger: 'blur' },
            //    {validator(rule, value, callback, source, options) {
            //       var errors = [];
            //       if(!/^1\d{10}$/.test(value)) {
            //         // errors.push(
            //             callback('手机号格式不正确');
            //         }
            //         callback(errors);
            //     }}

            // ],
            // status: [
            //     { required: true, message: '状态不能为空', trigger: 'change' }
            // ],
           
        },
      }
    },
    methods: {
      handleSubmit:function () {
        let that = this;
        if(that.activeName == "修改"){
          let selection = that.selectionRows[0];
          let formVarietyInforma = that.formValidate;
          formVarietyInforma.id = selection.id;
          formVarietyInforma.segNo = selection.segNo;
          api.Currency.update(formVarietyInforma, resp => {
            // console.log(resp)
            if(resp.code == 0){
              that.$Message.success('修改成功!');
              that.addModel = false;
              that.getLists(that.pagerData.page.pageCurrent,that.pagerData.page.pagesize);
            }
            
          }, error => {

          })
        }
        if(that.activeName == '新增'){
          api.Currency.addCurrency(that.formValidate, resp => {
            console.log(resp)
            if(resp.code == 0){
              that.$Message.success('新增成功!');
              that.addModel = false;
              that.getLists(that.pagerData.page.pageCurrent,that.pagerData.page.pagesize);
            }
            
          }, error => {

          })
        }
      },
      getSelection:function(selection){
        // console.log(222)
          console.log(selection)
          this.selectionRows = selection;
          // return selection;
      },
      // 搜索关键词
      showKeyList:function(){
          let that = this;
          // if(that.key == ''){
          //      that.$Message.error('查询关键词不能为空!');
          // }else{
            // console.log('通过关键词获取列表')
             api.Currency.getLists({
                  'page':that.pagerData.page.pageCurrent,
                  'limit':that.pagerData.page.pagesize,
                  'currencyName':that.key,
              }, resp => {
                // console.log(resp)
                // 获取分页展示list
                that.pagerData.data = resp.page.list;
                // console.log(this.pagerData.data)
                // 获取分页总条数
                 that.pagerData.page.totalCount = resp.page.totalCount;
                 //that.key = '';
              }, error => {
                
              })

          //}
      },
        // 新增 初始化数据
      addAdmin:function(){
          this.activeName = '新增';
          this.formValidate={
            // currencyId:'',
            currencyName:'',
            currencyEid: '',
            decimalDigits: '',
            convertType: '',
          },
          this.addModel = true
      },
      // 修改
      upDateAdmin:function(index){
        console.log(this.selectionRows)
        this.activeName = '修改';
        if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
            this.$Message.error('请选择一条记录!');
            return;
        }
        if(this.selectionRows.length > 1){
           this.$Message.error('一次只能选择一个进行修改!');
           return;
        }
          this.formValidate={
            // currencyId:this.selectionRows[0].currencyId,
            currencyName:this.selectionRows[0].currencyName,
            currencyEid: this.selectionRows[0].currencyEid,
            decimalDigits:this.selectionRows[0].decimalDigits,
            convertType: this.selectionRows[0].convertType,
          },
          this.addModel = true
      },
      delAdmins:function(){
        let that = this;
        if(that.selectionRows.length == undefined || that.selectionRows.length == 0){
            that.$Message.error('请至少选择一条记录!');
            return;
        }
        var currencyIds = [];
        for(var i=0 ;i < that.selectionRows.length; i++){
            console.log(i);
            currencyIds.push(that.selectionRows[i].id);
        }
        api.Currency.delete(currencyIds
        , resp => {
          console.log(resp)
          if(resp.code == 0){
            that.$Message.success('删除成功!');
            that.getLists(that.pagerData.page.pageCurrent,that.pagerData.page.pagesize);
          }
        }, error => {
        })
      },

      getLists:function(pageCurrent,pagesize){
          let that = this;
          let token = sessionStorage.getItem("token");
          let data = {
              'page':pageCurrent,
              'limit':pagesize,
          }
          api.Currency.getLists(data, resp => {
            console.log(resp)
             // 获取分页展示list
             that.pagerData.data = resp.page.list;
             // 获取分页总条数
             that.pagerData.page.totalCount = resp.page.totalCount;
            // this.getallgateway();
          }, error => {

          })
      },
      // 分页 -- 页数改变
      onChange:function(curpage){  
          // alert("当前页面页码是：" + curpage);
          this.pagerData.page.pageCurrent = curpage;
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
      },
      // 分页 -- pageSize 改变
      sizeChange:function(size){
       // alert("当前页面size是：" + size);
        this.pagerData.page.pagesize = size;
        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
      } ,
    },
    mounted:function(){ 
     // ----------- 权限显示start -------------
      var permissions = JSON.parse(localStorage.getItem('menuLeftLists'));
      console.log(permissions)
      // 获取当前的地址
      let path = this.$route.matched[1].path ;
      // console.log(this.permissionsLists)
      var len = permissions.length;
     
      for(var i=0;i<len;i++){
          if(path.indexOf(permissions[i].url) != -1){
             this.permissionsLists =  permissions[i].list
          }
      }
      // console.log(this.permissionsLists)
      // 获取权限
      this.permissionsLists.forEach(r=>{
        console.log(r.name)
        if(r.name == "查看"){
          this.isbutShow.selectBut = true;
        }else if(r.name == "新增"){
          this.isbutShow.addBut = true;
        }else if(r.name == "修改"){
          this.isbutShow.updateBut = true;
        }else if(r.name == "删除"){
           this.isbutShow.delBut = true;
        }

      })
       // ----------- 权限显示end -------------

        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
    },
    components: {
      //leftBar,
    }
  }
</script>



// WEBPACK FOOTER //
// currency.vue?9a67befa